import React from "react";
import './Security.css';
const SecurityPage = () => {
  return (
    <div className="security-ap row">
      <div className="security-wrap col-xl-12">

        {/* HERO */}
        <section className="security-hero">
          <h1>Security</h1>
          <p>Built on Trust. Protected by Design.</p>
          <p>At Garshya, security isn’t just a feature in the background. It’s a promise that every interaction, every transaction, and every piece of data is handled with care and responsibility.</p>
        </section>

        {/* SECTIONS */}
        <section className="security-section">
          <h2>Secure Transactions</h2>
          <ul>
            <li>All payments are processed through trusted and certified payment gateways</li>
            <li>We use industry-standard encryption (SSL/TLS) to protect your data during transactions</li>
            <li>Additional authentication (OTP / 3D Secure) adds an extra layer of safety</li>
          </ul>
          <p>Your financial information stays confidential and protected at all times.</p>

          <h2>Data Protection</h2>
          <ul>
            <li>We collect only the necessary information required to process your orders and improve your experience</li>
            <li>Your personal data is stored and handled in accordance with applicable Indian laws</li>
            <li>We do not sell or misuse your personal information</li>
          </ul>
          <p>Your trust is treated as data we must protect — not exploit.</p>

          <h2>Account Safety</h2>
          <ul>
            <li>Keep your login credentials confidential</li>
            <li>Avoid sharing OTPs or passwords with anyone</li>
            <li>Always use secure devices and networks while accessing your account</li>
          </ul>
          <p>Garshya will never ask for sensitive information via calls, emails, or messages.</p>

          <h2>Fraud Prevention</h2>
          <ul>
            <li>Orders and transactions may be monitored for suspicious activity</li>
            <li>Additional verification may be required in certain cases to ensure authenticity</li>
            <li>We reserve the right to hold, cancel, or review transactions for security reasons</li>
          </ul>
          <p>This helps us maintain a safe and reliable ecosystem for all users.</p>

          <h2>Platform Security</h2>
          <ul>
            <li>Regular monitoring and updates to protect against vulnerabilities</li>
            <li>Restricted access to sensitive systems</li>
            <li>Continuous improvement of security practices</li>
          </ul>
          <p>We work proactively to keep the platform stable, secure, and resilient.</p>

          <h2>Responsible Disclosure</h2>
          <p>If you identify a potential security issue or vulnerability, we encourage you to report it responsibly.</p>
          <p> <a href="mailto:security@garshya.com" className="security-email">security@garshya.com</a></p>
          <p>Our team will review and address it with priority.</p>

          <h2>Your Role in Security</h2>
          <ul>
            <li>Security is a shared responsibility</li>
            <li>Verify product and payment details before confirming orders</li>
            <li>Report suspicious activity immediately</li>
            <li>Stay informed and cautious while transacting online</li>
          </ul>
          <p>Garshya security isn’t just about protection. It’s about giving you the confidence to choose freely.</p>
        </section>

      </div>
    </div>
  );
};

export default SecurityPage;